export default "__VITE_ASSET__BiaTxIoC__"